<div style="width:100%; height:100%;overflow: hidden;position: absolute;display: flex;justify-content:center;align-items: center;flex-direction: column;background-color:#EEEEEE;">
    <div style="height: 216px; width: 370px;">
        <p class="icontg-icon_401" style="color: #A2A2A2;font-size:143.25pt;text-align: center;">

        </p>
    </div>
    <div style="background-color: #E7E7E7; 	width: 496px;overflow: hidden;display: flex;justify-content: center;align-items: center;flex-direction: column;padding-top: 15px; padding-bottom: 15px;">
        <div style="width: 370px;">
            <p style="color: #A2A2A2;	font-family: Montserrat-Bold;	font-size: 20px;line-height: 25px;	text-align: center;text-transform: none;">
                ¡Ups! Tu camino termina aquí
            </p>
        </div>
        <div style="width: 287px;">
            <p style="color: #A2A2A2; font-family: 'Montserrat-Light'; font-size: 17px; font-weight: 300; line-height: 25px; text-align: center;text-transform: none;">
                Parece que no tienes permiso para continuar en esta dirección.
            </p>
        </div>
    </div>
    <div style="width: 0; height: 0; border-left: 10px solid transparent; border-right: 10px solid transparent; border-top: 20px solid #E7E7E7;"></div>
    <div style="width: 295px;height:61px;margin-top: 20px;">
        <p style="color: #A2A2A2;	font-family: Montserrat-Bold;	font-size: 50px;	font-weight: bold;	line-height: 61px;	text-align: center;">
            ERROR 401
        </p>
    </div>
</div>
